module.exports = __webpack_public_path__ + "media/components/assets/icons/image_plus-545a570f3aa52a110b7af1645c18e422.svg";